function loadImage(src: string, crossOrigin?: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    if (crossOrigin) img.crossOrigin = crossOrigin;
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`Image load failed: ${src}`));
    img.src = src;
  });
}

const MARGIN_LEFT = 50;
const HEIGHT_RATIO = 1 / 5;

export async function applyWatermark(photoFile: File, watermarkSrc: string): Promise<Blob> {
  const photoUrl = URL.createObjectURL(photoFile);
  try {
    const [photo, wm] = await Promise.all([
      loadImage(photoUrl),
      loadImage(watermarkSrc, "anonymous"),
    ]);

    const imgW = photo.naturalWidth;
    const imgH = photo.naturalHeight;
    const canvas = document.createElement("canvas");
    canvas.width = imgW;
    canvas.height = imgH;
    const ctx = canvas.getContext("2d")!;
    ctx.drawImage(photo, 0, 0, imgW, imgH);

    const wmH = imgH * HEIGHT_RATIO;
    const wmW = wm.naturalWidth * (wmH / wm.naturalHeight);
    const x = MARGIN_LEFT;
    const y = (imgH - wmH) / 2;
    ctx.drawImage(wm, x, y, wmW, wmH);

    return await new Promise((resolve, reject) => {
      canvas.toBlob(
        (blob) => (blob ? resolve(blob) : reject(new Error("toBlob returned null"))),
        "image/jpeg",
        0.92
      );
    });
  } finally {
    URL.revokeObjectURL(photoUrl);
  }
}
